$(document).ready(function () {
  const cartContainer      = $('.sidecart__contents');
  const freeShipThreshold  = 15000;

  function displayFreeShip( subTotal ) {
    $('.sidecart__promo.freeship').remove();

    let tmplComplete = `<div class="sidecart__promo__success js-sidecart-promo-success" style="display: block !important;">
<h2 class="sidecart__promo__title">Score! You unlocked shipping discounts! </h2><a href="#" id="rest-toggle" onclick="ShowRest()">(Restrictions apply)</a>
						<div id="rest-details" style="display:none;"><p>Free Shipping Available</p><a href="#" onclick="HideRest()">Close</a></div>
                        </div>`;

    let tmplInProgress = `<div class="js-sidecart-promo-details">
                            <p class="sidecart__promo__description" style="margin-top: 0;">You are <span class="js-sidecart-promo-threshold">${ Shopify.formatMoney( freeShipThreshold - subTotal ) }</span> away from shipping discounts. <a href="#" id="rest-toggle" onclick="ShowRest()">(Restrictions apply)</a></p>
							<div id="rest-details" style="display:none;"><p>Free Shipping Available</p><a href="#" onclick="HideRest()">Close</a></div>
                            <div class="sidecart__promo__progress">
                              <div class="sidecart__promo__progress__bar js-sidecart-promo-progress" style="width: ${ subTotal / freeShipThreshold * 100 }%;"></div>
                            </div>
                          </div>`;

    let tmplWrapper = `<div class="sidecart__promo js-sidecart-promo freeship">
                        ${ subTotal >= freeShipThreshold ? tmplComplete : tmplInProgress }
                      </div>`;
      
    cartContainer.prepend( tmplWrapper );
  }

  function updateFreeShip(cart) {
    const subTotal           = cart.total_price;
    const currentGWP         = $('.js-sidecart-promo').not('.freeship');
    const currentGWPFinished = currentGWP.length ? currentGWP.children('.js-sidecart-promo-success').first().is(':visible') : true;

    if( currentGWPFinished ) {
      displayFreeShip( subTotal );
    } else {
      $('.js-sidecart-promo.freeship').remove();
    }
  }

  document.addEventListener('sidecart:updated', function (e) {
    updateFreeShip(e.detail);
  });

  if (typeof RC !== 'undefined' && RC.cart) {
    RC.cart.get(function (cart) {
      updateFreeShip(cart);
    });
  }
});

function ShowRest() {
    document.getElementById("rest-details").style.display = "";
}

function HideRest() {
    document.getElementById("rest-details").style.display = "none";
}